var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f57c00;}.cls-2{fill:#999;}.cls-3{fill:#666;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "outline color",
    id: "outline_color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,60a1,1,0,0,1-.5-.13l-9-5a1,1,0,0,1,0-1.74l9-5a1,1,0,0,1,1.43.49A14.29,14.29,0,0,1,24,54a14.4,14.4,0,0,1-1.06,5.38A1,1,0,0,1,22,60Zm-7-6,6.4,3.56A12.17,12.17,0,0,0,22,54a12,12,0,0,0-.54-3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,60H22a1,1,0,0,1-.83-.44,1,1,0,0,1-.1-.94A12.33,12.33,0,0,0,22,54a12.13,12.13,0,0,0-.92-4.62,1,1,0,0,1,.1-.94A1,1,0,0,1,22,48H59a1,1,0,0,1,1,1V59A1,1,0,0,1,59,60ZM23.42,58H58V50H23.42A13.87,13.87,0,0,1,24,54,14.27,14.27,0,0,1,23.42,58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,56H24a1,1,0,0,1,0-2H47a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52,59a1,1,0,0,1-1-1V50a1,1,0,0,1,2,0v8A1,1,0,0,1,52,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.27,48.61a1,1,0,0,1-.91-.59L4.56,23.83a5,5,0,0,1,2.52-6.6l20.17-9A1,1,0,0,1,28.07,10l-20.17,9a3,3,0,0,0-1.52,4L17.18,47.2a1,1,0,0,1-.5,1.32A1,1,0,0,1,16.27,48.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.74,22.68a1,1,0,0,1-.92-.6,1,1,0,0,1,.51-1.32l8.22-3.67a1,1,0,1,1,.81,1.83l-8.22,3.67A1,1,0,0,1,16.74,22.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.44,29.38A1,1,0,0,1,16,27.47l6.78-3a1,1,0,0,1,.82,1.82l-6.78,3A1,1,0,0,1,16.44,29.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.89,34.85a1,1,0,0,1-.41-1.91l2.29-1a1,1,0,0,1,.82,1.82l-2.29,1A1,1,0,0,1,18.89,34.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51,46a.75.75,0,0,1-.26,0,1,1,0,0,1-.7-1.22L57.9,16.11a3,3,0,0,0-.3-2.28,2.9,2.9,0,0,0-1.81-1.4L32.65,6.08A3,3,0,0,0,29,8.2L20.77,38.09a3,3,0,0,0,.29,2.28,3,3,0,0,0,1.81,1.41L31.12,44A1,1,0,0,1,30.6,46L22.35,43.7a5,5,0,0,1-3-2.34,4.93,4.93,0,0,1-.47-3.79L27,7.67a5,5,0,0,1,6.14-3.51L56.31,10.5a5,5,0,0,1,3.51,6.13L52,45.26A1,1,0,0,1,51,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.46,17.36a1.24,1.24,0,0,1-.27,0L38.51,15A1,1,0,0,1,39,13l8.68,2.38a1,1,0,0,1-.26,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.77,23.94a1.24,1.24,0,0,1-.27,0L34,20A1,1,0,1,1,34.56,18L49,22a1,1,0,0,1-.26,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.18,29.73a.78.78,0,0,1-.26,0l-14.47-4A1,1,0,1,1,33,23.81l14.47,4a1,1,0,0,1,.7,1.22A1,1,0,0,1,47.18,29.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.6,35.52a.84.84,0,0,1-.27,0l-14.47-4a1,1,0,1,1,.53-1.93l14.47,4a1,1,0,0,1,.7,1.23A1,1,0,0,1,45.6,35.52Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.b71903dec803c1ab14889fab63e57a44.svg";
export { ForwardRef as ReactComponent };